import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';
import { isAiTemplateEnabled } from '@/ui/helpers/featureHelper';
import { h, defineComponent } from 'vue';
import { Button } from '@/ui/components/Button';
import { locales, t } from '@/ui/i18n/i18n';
import { user } from '@/ui/auth/auth';

interface ChecklistCreateButtonProps {
  text?: string;
  classes?: string;
  hideIcon?: boolean;
  trackClick?: boolean;
  query?: {
    fromRoute?: string;
  };
}

const query = (locale: locales) => {
  switch (locale) {
    case 'de':
      return {
        utm_campaign: 'Onboarding',
        utm_source: 'email',
        utm_medium: 'email',
        utm_term: 'sende uns deine Checkliste',
        utm_content: 'S - No template - DE',
        product_tour_id: '270197',
      };

    case 'es':
      return {
        utm_campaign: 'Onboarding',
        utm_source: 'email',
        utm_medium: 'email',
        utm_content: 'Send us your form',
      };

    case 'en':
    case 'fr':
    case 'pt-BR':
    default:
      return {
        utm_campaign: 'Onboarding',
        utm_source: 'email',
        utm_medium: 'email',
        utm_content: 'Send us your form',
        product_tour_id: '270184',
      };
  }
};

export const ChecklistCreateButton = defineComponent<ChecklistCreateButtonProps>({
  name: 'ChecklistCreateButton',
  props: ['text', 'query', 'trackClick', 'hideIcon'],
  setup(props) {
    return function render() {
      const clickEvent = props.query?.fromRoute === 'home'
        ? CLICK_EVENTS.DASHBOARD.CREATE_TEMPLATE
        : CLICK_EVENTS.CREATE_TEMPLATE;

      return h(Button, {
        class: props.classes ? props.classes : '',
        nativeOn: {
          click: () => props.trackClick && trackClick(clickEvent),
        },
        attrs: {
          tag: 'router-link',
          to: {
            name: isAiTemplateEnabled() ? 'checklistChooseMethod' : 'checklistChooseTemplate',
            query: {
              ...query(user.value.locale),
              ...(props.query || {}),
            },
          },
          iconLeft: props.hideIcon ? null : 'plus',
        },
      }, props.text ?? t('checklist.create-template'));
    };
  },
});
